// A company may lack an Aspire companyId (contact-promoted residential group);
// key such rows by name so selection/check/exclude state stays stable.
export const companyKeyOf = (company) =>
  company.companyId !== null && company.companyId !== undefined
    ? `id:${company.companyId}`
    : `name:${company.companyName}`
